module.exports = __webpack_public_path__ + "static/media/Mockup_App_WEB.0ed158a4.png";